export const cancellationList = ["$2,500", "$5,000", "$10,000", "$25,000", "$50,000", "$Unlimited"];
